import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import type { DatePickerProps } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import moment, { Moment } from "moment";
import kitchen from "../../../../../apis/admin/kitchenService";
import menusAdmin from "../../../../../apis/admin/menuService";
import { Link, useNavigate, useParams } from "react-router-dom";
import notificationHandler from "../../../../atoms/Notification";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import kitchenAdmin from "../../../../../apis/admin/kitchenService";
import { useSelector } from "react-redux";
import { RangePickerProps } from "antd/es/date-picker";
import "../menu.scss";

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

const dateFormat = "YYYY-MM-DD hh:mm:ss";

const EditMenu = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const userName = Form.useWatch("kitchen", form);
  const [ListKitchen, setListKitchen] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  const confirm = (values: any) => {
    modal.confirm({
      title: "Bạn có chắc chắn muốn thay đổi dữ liệu?",
      icon: <ExclamationCircleOutlined />,
      okText: "Đồng ý",
      cancelText: "Không",
      onOk: () => onFinish(values),
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const { id }: any = useParams();
  useEffect(() => {
    menusAdmin
      .getOneMenu(id)
      .then((data: any) => {
        const datas = {
          kitchenId: data.data.data.payload.kitchenId[0],
          applicableDate: moment(
            dayjs(data.data.data.payload.applicableDate, dateFormat).toDate()
          ),
          foodList: data.data.data.payload.foodList,
          menuType: data.data.data.payload.menuType,
          paymentAmount: data.data.data.payload.paymentAmount,
        };
        form.setFieldsValue(datas);
      })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      });
  }, []);

  useEffect(() => {
    kitchenAdmin
      .getKitchenData(1, "")
      .then((data: any) => {
        setListKitchen(data.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      });
  }, []);

  const onFinish = (values: any) => {
    setLoading(true);
    const applicableDate = moment(new Date(+values.applicableDate)).format(
      dateFormat
    );
    const data = {
      kitchenIds: [values.kitchenId],
      applicableDate: applicableDate,
      foodList: values.foodList.toString(),
      menuType: values.menuType,
      paymentAmount: values.paymentAmount,
    };
    menusAdmin
      .updateMenu(data, id)
      .then(() => {
        notificationHandler("success", "Sửa thực đơn thành công!");
        navigate("/admin/listMenuSpecial");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps["disabledDate"] = (current: Moment) => {
    // Can not select days before today and today
    return current && current < moment().subtract(1, "day").endOf("day");
  };

  const validateSpecialCharacters = (_: any, value: any) => {
    const specialCharsRegex = /[!"#$%&'()*+,\./:;<=>?@[\\\]^`{|}~]/;
    if (specialCharsRegex.test(value)) {
      return Promise.reject("Dữ liệu nhập vào không được chứa ký tự đặc biệt!");
    }
    return Promise.resolve();
  };

  return (
    <div id="edit-menu" className="p-[20px]">
      <Spin indicator={antIcon} spinning={loading} />
      <Title className="!text-[20px]">Sửa thực đơn</Title>
      <Form
        form={form}
        name="change menu"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        layout={"vertical"}
        style={{ maxWidth: 600 }}
        onFinish={confirm}
        autoComplete="off"
      >
        <Form.Item
          name={"applicableDate"}
          label={"Ngày áp dụng thực đơn"}
          rules={[
            { required: true, message: "Vui lòng chọn ngày áp dụng thực đơn!" },
          ]}
        >
          <DatePicker
            placeholder="Chọn ngày áp dụng thực đơn"
            className="w-full"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <Form.Item
          name={"kitchenId"}
          label={"Chọn bếp ăn"}
          rules={[{ required: true, message: "Vui lòng chọn bếp ăn!" }]}
        >
          {/* <Select placeholder='Chọn bếp ăn' allowClear>
                        {ListKitchen.map((item: any, key: number) => <Select.Option key={key} value={item.id}>{item.kitchenName}</Select.Option>)}
                    </Select> */}
          {/* <Select placeholder='Chọn bếp ăn'
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: string, option: any) => (option?.label ?? '').toLowerCase().includes(input.trim())}
                        options={ListKitchen?.map((item: any, key: number) => ({
                            value: item.id,
                            label: item.kitchenName,
                        }))}
                    /> */}
          <Select
            // mode="multiple"
            allowClear
            showSearch
            // style={{ width: '100%' }}
            optionFilterProp="children"
            filterOption={(input: string, option: any) =>
              (option?.label ?? "").toLowerCase().includes(input.trim())
            }
            placeholder="Chọn bếp ăn"
            options={ListKitchen?.map((item: any, key: number) => ({
              value: item.id,
              label: item.kitchenName,
            }))}
            defaultValue={
              ListKitchen?.length === 1 ? [ListKitchen[0]?.id] : undefined
            }
          />
        </Form.Item>
        <Form.Item
          name={"menuType"}
          label={"Chọn bữa ăn"}
          rules={[{ required: true, message: "Vui lòng chọn bữa ăn!" }]}
        >
          <Select
            placeholder="Chọn bữa ăn"
            allowClear
            options={[
              {
                value: 1,
                label: "Bữa sáng",
              },
              {
                value: 2,
                label: "Bữa trưa",
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          name={"foodList"}
          label={"Tên món"}
          rules={[{ required: true, message: "Vui lòng nhập tên món ăn!" }]}
        >
          <Input placeholder="Nhập tên món ăn" showCount maxLength={200} />
        </Form.Item>
        <Form.Item
          name={"paymentAmount"}
          label={"Giá suất ăn"}
          rules={[
            { required: true, message: "Vui lòng nhập giá suất ăn!" },
            { validator: validateSpecialCharacters },
          ]}
        >
          <InputNumber
            placeholder="Nhập giá suất ăn"
            maxLength={7}
            min={0}
            precision={2}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
            className="w-full"
          />
        </Form.Item>
        <div className="flex">
          <Button
            htmlType="button"
            type="primary"
            className="mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white"
          >
            <Link to={"/admin/listMenuSpecial"} className="flex items-center">
              <ArrowLeftOutlined className="mr-2" /> Quay lại
            </Link>
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            className="mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
            loading={loading}
          >
            <SaveOutlined /> Cập nhật
          </Button>
          <Button
            htmlType="reset"
            className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
            danger
          >
            <ReloadOutlined /> Đặt lại
          </Button>
        </div>
      </Form>
      {contextHolder}
    </div>
  );
};

export default EditMenu;
